import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { InputLabel, Select } from '@components/Common';
import { ShipmentType } from '@api/queries/inventory';

const ShipmentTypeFilterColumn = styled.div`
  width: 200px;
`;

interface Props {
  value: ShipmentType | null;
  onChange: (value: ShipmentType | null) => void;
  isDisabled?: boolean;
}

const ShipmentTypeFilterControlled: React.FC<Props> = ({
  value,
  onChange,
  isDisabled = false,
}) => {
  const { t } = useTranslation();

  const shipmentTypes = [
    { value: ShipmentType.Truck, label: t('entry.shipment_types.truck') },
    { value: ShipmentType.Ship, label: t('entry.shipment_types.ship') },
    { value: ShipmentType.Pipe, label: t('entry.shipment_types.pipe') },
    { value: ShipmentType.Train, label: t('entry.shipment_types.train') },
    { value: ShipmentType.ContainerTrain, label: t('entry.shipment_types.containertrain') },
    { value: ShipmentType.ContainerTruck, label: t('entry.shipment_types.containertruck') },
  ];

  const selectedShipmentType = shipmentTypes.find(i => i.value === value) || null;

  const handleChange = (option: { value: ShipmentType } | null, actionMeta: { action: string }) => {
    onChange(actionMeta.action === 'clear' ? null : option?.value ?? null);
  };

  return (
    <ShipmentTypeFilterColumn className="column">
      <InputLabel htmlFor="shipmentTypeFilter">{t('entry.shipment_type')}</InputLabel>
      <Select
        name="shipmentTypeFilter"
        isClearable={true}
        isDisabled={isDisabled}
        placeholder={t('entry.select_shipment_type')}
        value={selectedShipmentType}
        onChange={handleChange}
        options={shipmentTypes}
      />
    </ShipmentTypeFilterColumn>
  );
};

export default ShipmentTypeFilterControlled;
